var _path;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgIconMenuStarHalfFilled(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M21.55 18.207l-.738.736.181 1.028 1.095 6.181-5.091-2.926-.997-.574-.997.574-5.091 2.926 1.095-6.181.183-1.028-.739-.736-4.431-4.424 5.949-.816 1.098-.152.454-1.008L16 6.3l2.48 5.507.455 1.008 1.096.152 5.95.816-4.431 4.424zm6.502-6.157l-7.748-1.066-3.305-7.338A1.082 1.082 0 0016 3c-.402 0-.804.216-.998.646l-3.305 7.338-7.749 1.066c-.898.123-1.267 1.226-.624 1.869l5.714 5.703-1.432 8.083A1.101 1.101 0 008.686 29c.18 0 .366-.046.544-.148L16 24.96l6.771 3.892c.177.102.364.148.544.148.638 0 1.207-.578 1.08-1.295l-1.432-8.083 5.713-5.703c.644-.643.274-1.746-.624-1.869z",
    fill: props.color
  }), /*#__PURE__*/React.createElement("mask", {
    id: "icon_menu_star_half_filled_svg__a",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 2,
    y: 1,
    width: 14,
    height: 29
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#D9D9D9",
    d: "M2 1h14v29H2z"
  }))), /*#__PURE__*/React.createElement("g", {
    mask: "url(#icon_menu_star_half_filled_svg__a)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M28.052 12.05l-7.748-1.064-3.305-7.339c-.388-.863-1.609-.863-1.998 0l-3.303 7.34-7.75 1.063c-.898.123-1.267 1.227-.624 1.87l5.714 5.702-1.432 8.083c-.162.92.817 1.612 1.624 1.148L16 24.96l6.771 3.893c.807.464 1.786-.229 1.624-1.148l-1.432-8.083 5.713-5.703c.644-.642.274-1.746-.624-1.869z",
    fill: props.color
  })));
}

export default SvgIconMenuStarHalfFilled;